import {authURL} from "../../http/urls";
import {AUTH_TOKEN_MAX_AGE_SECONDS, getCookie, setCookie} from "../../http/cookies";
import {userSlice} from "../../store/reducer/UserSlice";
import {jwtDecode} from "jwt-decode";
import {User} from "../../models/Models";
import {AuthStatus} from "../../models/StoreModels";
import axios from "axios";
import {AppDispatch} from "../../store/store";

export const UpdateAuth = async (dispatch: AppDispatch) => {
    const {LogIn, SetAuthStatus} = userSlice.actions
    const tokenCookie = getCookie("token")
    if (tokenCookie) {
        try {
            const tokenDecoded: User = jwtDecode(tokenCookie)
            dispatch(LogIn(tokenDecoded))
            const response = (await axios.get(authURL, {
                    headers: {
                        Authorization: `Bearer ${tokenCookie}`
                    }
                }
            )).data.token
            setCookie("token", response, AUTH_TOKEN_MAX_AGE_SECONDS)
        } catch (e) {
            dispatch(SetAuthStatus(AuthStatus.Unauthorized))
        }
    } else {
        dispatch(SetAuthStatus(AuthStatus.Unauthorized))
    }
}